<div class="tray-container container-fluid" [attr.data-testid]="vm.slug">
  <div
    class="d-flex align-items-md-center"
    [class.flex-row-reverse]="vm.layout === 'RightAligned'"
    [class.row]="vm.layout === 'LeftAligned'"
  >
    <div class="col-md-12">
      <div
        class="content-area d-flex flex-column justify-content-center align-items-center"
        [class.align-items-md-end]="vm.layout === 'RightAligned'"
        [class.align-items-md-start]="vm.layout === 'LeftAligned'"
      >
        <div
          [class.light-text]="isLightTitle"
          [class.text-right]="vm.layout === 'RightAligned'"
          class="title"
          [innerHTML]="vm.title | lineBreak"
        ></div>
        <div class="divider-line"></div>
        <div
          [class.light-text]="isLightDescription"
          *ngIf="vm.description"
          class="description"
          [innerHTML]="vm.description | lineBreak"
        ></div>

        <osn-shared-marketing-action-button
          class="d-none d-md-block"
          *ngIf="vm.primaryButton"
          [actionButton]="vm.primaryButton"
          [buttonText]="primaryButtonText"
          data-testid="LandingPage.mlpCtaButton"
          (measureClick)="onCtaButtonClick()"
        ></osn-shared-marketing-action-button>
      </div>
    </div>
    <div class="col-md-12">
      <div class="img-container d-flex flex-column justify-content-center align-items-center">
        <img
          osnSharedUseAsPicture
          [src]="vm.backgroundImageUrl"
          [imgQuery]="imgQuery"
          [alt]="vm.title"
          data-testid="MarketingLandingPage.marketingTrayContainersCtaImage"
        />

        <osn-shared-marketing-action-button
          class="d-block d-md-none"
          *ngIf="vm.primaryButton"
          [actionButton]="vm.primaryButton"
          [buttonText]="primaryButtonText"
          data-testid="LandingPage.mlpCtaButton"
          (measureClick)="onCtaButtonClick()"
        ></osn-shared-marketing-action-button>
      </div>
    </div>
  </div>
</div>
